import { trackViewCart } from '@jbhi-fi/utils/src/ga4Tracking';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { transformCartItemForTracking } from './transformCartItemForTracking';
import { JbCart, JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';
import { getMarketplaceCartType } from '@jbhi-fi/utils/src/ga4Tracking/ga4utils';

export const trackViewCartShopify = async (cart: JbCart | undefined, viewLocation?: string) => {
  if (cart?.items) {
    const formattedCartItems = cart.items.map((item: JbCartItem) => transformCartItemForTracking(item));
    trackViewCart({
      viewLocation,
      cartTotalValue: cart.total_price / 100,
      currency: getStoreCurrency(),
      cartItems: formattedCartItems,
      marketplace_cart_type: formattedCartItems.length > 0 ? getMarketplaceCartType(formattedCartItems) : '',
    });
  }
};
